(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const drawer = $('.cart-drawer');
  const overlay = $('.drawer-overlay');
  const toast = $('.toast');
  $$('.newsletter form').forEach((form, index) => {
    form.id = `NewsletterForm-${index + 1}`;
    form.action = form.action.replace(/#.*$/, `#${form.id}`);
  });

  const money = cents => {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  };

  window.themeFloatingWidgets = {
    makeDraggable(element, storageName, onMove) {
      if (!element || !window.PointerEvent) return;
      const margin = 12;
      const storageKey = () => `${storageName}:${innerWidth < 750 ? 'mobile' : 'desktop'}`;
      let activeStorageKey = storageKey();
      let start;
      let moved = false;
      let suppressClick = false;

      const clamp = (x, y) => {
        const maxX = Math.max(margin, innerWidth - element.offsetWidth - margin);
        const maxY = Math.max(margin, innerHeight - element.offsetHeight - margin);
        return {
          x: Math.min(maxX, Math.max(margin, x)),
          y: Math.min(maxY, Math.max(margin, y))
        };
      };
      const position = (x, y, persist = false) => {
        const next = clamp(x, y);
        Object.assign(element.style, {
          left: `${Math.round(next.x)}px`,
          top: `${Math.round(next.y)}px`,
          right: 'auto',
          bottom: 'auto'
        });
        if (persist) {
          try { localStorage.setItem(activeStorageKey, JSON.stringify(next)); } catch (error) {}
        }
        onMove?.(next);
      };
      const restore = () => {
        let saved;
        try { saved = JSON.parse(localStorage.getItem(activeStorageKey)); } catch (error) {}
        if (!Number.isFinite(saved?.x) || !Number.isFinite(saved?.y)) return false;
        position(saved.x, saved.y);
        return true;
      };
      const restoreCssPosition = () => {
        Object.assign(element.style, { left: '', top: '', right: '', bottom: '' });
        requestAnimationFrame(() => {
          const rect = element.getBoundingClientRect();
          onMove?.({ x: rect.left, y: rect.top });
        });
      };

      element.title = `${element.title ? `${element.title}. ` : ''}Drag or use arrow keys to move`;
      element.setAttribute('aria-keyshortcuts', 'ArrowUp ArrowDown ArrowLeft ArrowRight');
      element.addEventListener('pointerdown', event => {
        if (event.button !== 0) return;
        const rect = element.getBoundingClientRect();
        start = { pointerX: event.clientX, pointerY: event.clientY, x: rect.left, y: rect.top };
        moved = false;
        element.setPointerCapture(event.pointerId);
      });
      element.addEventListener('pointermove', event => {
        if (!start || !element.hasPointerCapture(event.pointerId)) return;
        const deltaX = event.clientX - start.pointerX;
        const deltaY = event.clientY - start.pointerY;
        if (!moved && Math.hypot(deltaX, deltaY) < 7) return;
        moved = true;
        position(start.x + deltaX, start.y + deltaY);
      });
      element.addEventListener('pointerup', event => {
        if (!start) return;
        if (element.hasPointerCapture(event.pointerId)) element.releasePointerCapture(event.pointerId);
        if (moved) {
          const rect = element.getBoundingClientRect();
          position(rect.left, rect.top, true);
          suppressClick = true;
          setTimeout(() => { suppressClick = false; }, 400);
        }
        start = null;
      });
      element.addEventListener('pointercancel', () => { start = null; });
      element.addEventListener('click', event => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        suppressClick = false;
      }, true);
      element.addEventListener('keydown', event => {
        if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const rect = element.getBoundingClientRect();
        const step = event.shiftKey ? 40 : 10;
        position(
          rect.left + (event.key === 'ArrowRight' ? step : event.key === 'ArrowLeft' ? -step : 0),
          rect.top + (event.key === 'ArrowDown' ? step : event.key === 'ArrowUp' ? -step : 0),
          true
        );
      });
      window.addEventListener('resize', () => {
        const nextStorageKey = storageKey();
        if (nextStorageKey !== activeStorageKey) {
          activeStorageKey = nextStorageKey;
          if (restore()) return;
          restoreCssPosition();
          return;
        }
        if (!element.style.left) return;
        const rect = element.getBoundingClientRect();
        position(rect.left, rect.top, true);
      }, { passive: true });
      restore();
    }
  };

  function setDrawer(open) {
    drawer?.classList.toggle('open', open);
    overlay?.classList.toggle('open', open);
    drawer?.setAttribute('aria-hidden', String(!open));
    document.body.style.overflow = open ? 'hidden' : '';
  }

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 2200);
  }

  const escapeAttr = str => String(str || '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  // Guest favorites: persisted to the visitor's device for 30 days (matches the sign-in prompt copy).
  const Favorites = (() => {
    const KEY = 'lenovember:favorites';
    const MAX_AGE = 30 * 24 * 60 * 60 * 1000;
    const write = map => { try { localStorage.setItem(KEY, JSON.stringify(map)); } catch (e) {} };
    const read = () => {
      let map = {};
      try { map = JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { map = {}; }
      const now = Date.now();
      let changed = false;
      Object.keys(map).forEach(h => { if (!map[h] || now - (map[h].ts || 0) > MAX_AGE) { delete map[h]; changed = true; } });
      if (changed) write(map);
      return map;
    };
    const has = handle => Boolean(handle && read()[handle]);
    const updateCount = () => {
      const n = Object.keys(read()).length;
      $$('[data-fav-count]').forEach(el => { el.textContent = n; el.hidden = n === 0; });
    };
    const toggle = (handle, data) => {
      if (!handle) return false;
      const map = read();
      if (map[handle]) delete map[handle]; else map[handle] = Object.assign({ handle, ts: Date.now() }, data);
      write(map); updateCount();
      return Boolean(map[handle]);
    };
    const remove = handle => { const map = read(); delete map[handle]; write(map); updateCount(); };
    const list = () => Object.values(read()).sort((a, b) => (b.ts || 0) - (a.ts || 0));
    const dataFromCard = card => {
      const link = card.querySelector('.product-card__title a');
      const img = card.querySelector('.product-card__media img');
      return {
        title: (link || card.querySelector('.product-card__title'))?.textContent.trim() || '',
        url: link?.getAttribute('href') || (card.dataset.productHandle ? '/products/' + card.dataset.productHandle : '#'),
        image: img?.currentSrc || img?.getAttribute('src') || '',
        priceHtml: card.querySelector('.product-card__price')?.innerHTML || '',
        ratingHtml: card.querySelector('.product-rating')?.outerHTML || ''
      };
    };
    return { read, has, toggle, remove, list, dataFromCard, updateCount };
  })();

  const setHeart = (heart, active) => {
    heart.classList.toggle('active', active);
    heart.setAttribute('aria-pressed', String(active));
    heart.setAttribute('aria-label', active ? 'Remove item from wishlist' : 'Add item to wishlist');
    heart.textContent = active ? '♥' : '♡';
  };

  async function getCart() {
    const response = await fetch(window.themeRoutes.cart, { headers: { Accept: 'application/json' } });
    // Shopify serves /cart.js as `text/javascript` (nosniff), so trust a JSON-parseable body
    // rather than the content-type header. Only a non-JSON body (HTML challenge) is a real failure.
    if (!response.ok) throw new Error('Shopify is verifying your connection. Please wait and try again.');
    try { return await response.json(); }
    catch { throw new Error('Shopify is verifying your connection. Please wait and try again.'); }
  }

  // Cart add-ons (shipping protection, priority production, gift box, message card) carry the
  // "Cart add-on" product type; they are not real products, so exclude them from the shown count.
  const CART_ADDON_TYPE = 'Cart add-on';
  const realItemCount = cart =>
    cart.items.reduce((n, i) => (i.product_type === CART_ADDON_TYPE ? n : n + i.quantity), 0);

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(el => el.textContent = realItemCount(cart));
    const items = $('[data-cart-items]');
    const summary = $('[data-cart-summary]');
    if (!items) return;
    summary?.classList.toggle('visible', cart.item_count > 0);
    if (!cart.items.length) {
      items.innerHTML = '<div class="empty-cart"><span>♡</span><h3>Your cart is empty</h3><p>Find a keepsake made just for them.</p><button type="button" class="button button-dark" data-cart-close>CONTINUE SHOPPING</button></div>';
    } else {
      items.innerHTML = cart.items.map(item => {
        const allocations = (item.line_level_discount_allocations || []).map(allocation =>
          `<span class="cart-line-discount">${escapeAttr(allocation.discount_application?.title || 'Automatic discount')} (−${money(allocation.amount)})</span>`
        ).join('');
        const original = item.original_line_price > item.final_line_price
          ? `<s class="cart-original-price">${money(item.original_line_price)}</s>` : '';
        return `<div class="cart-line">${item.image ? `<img class="cart-thumb" src="${item.image}&width=180" alt="">` : ''}<div><h3><a href="${item.url}">${item.product_title}</a></h3><small>${item.variant_title || 'PERSONALIZED GIFT'} · QTY ${item.quantity}</small>${allocations}<p class="price">${original}${money(item.final_line_price)}</p></div><button type="button" class="remove-item" data-line-key="${item.key}" aria-label="Remove ${item.product_title}">×</button></div>`;
      }).join('');
    }
    $('[data-cart-total]') && ($('[data-cart-total]').textContent = money(cart.total_price));
  }

  async function refreshCart(open = false) {
    try { const cart = await getCart(); renderCart(cart); if (open) setDrawer(true); }
    catch (error) { showToast(error.message); }
  }

  async function addToCart(formData) {
    const response = await fetch(window.themeRoutes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
    if (!response.ok) {
      const result = await response.json().catch(() => null); // /cart/add.js errors are JSON even as text/javascript
      throw new Error(result?.description || (response.status === 429 ? 'Shopify is verifying your connection. Please wait and try again.' : 'Could not add this item'));
    }
    return response.json().catch(() => null);
  }

  // After a product-page add: show the "added to cart" popup (assets/added-to-cart-popup.js) so the
  // shopper can keep personalizing another item here; anywhere without the popup, go to /cart.
  async function afterAdd(added) {
    const item = added?.items ? added.items[0] : added;
    if (!window.LenAddedToCart || !item?.product_title) { window.location.assign(window.themeRoutes.cartPage); return; }
    let count = 1;
    try {
      const cart = await getCart();
      renderCart(cart);
      count = realItemCount(cart);
      // Customily's preview URL can be on the cart line when the add response omits it.
      const line = cart.items?.find(entry => entry.key === item.key) || cart.items?.find(entry => entry.variant_id === item.variant_id);
      if (line?.properties) {
        const merged = { ...line.properties };
        for (const [key, value] of Object.entries(item.properties || {})) {
          if (value != null && value !== '') merged[key] = value;
        }
        item.properties = merged;
      }
    } catch { /* popup still useful without a count */ }
    window.LenAddedToCart.open(item, count);
  }

  document.addEventListener('click', async event => {
    const cartButton = event.target.closest('.cart-button');
    if (cartButton) { event.preventDefault(); window.location.assign(window.themeRoutes.cartPage); return; }
    if (event.target.closest('[data-cart-close]')) { event.preventDefault(); setDrawer(false); return; }
    const quickAdd = event.target.closest('.quick-add[data-variant-id]');
    if (quickAdd) {
      event.preventDefault(); event.stopPropagation();
      quickAdd.disabled = true;
      const data = new FormData(); data.append('id', quickAdd.dataset.variantId); data.append('quantity', '1');
      try { await addToCart(data); window.location.assign(window.themeRoutes.cartPage); }
      catch (error) { showToast(error.message); }
      finally { quickAdd.disabled = false; }
      return;
    }
    const remove = event.target.closest('[data-line-key]');
    if (remove) {
      remove.disabled = true;
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: remove.dataset.lineKey, quantity: 0 }) });
      refreshCart(); return;
    }
    const heart = event.target.closest('.heart');
    if (heart && !heart.hasAttribute('data-fav-remove')) {
      event.preventDefault();
      const card = heart.closest('.product-card');
      const handle = card?.dataset.productHandle;
      if (handle) {
        setHeart(heart, Favorites.toggle(handle, Favorites.dataFromCard(card)));
      } else {
        setHeart(heart, !heart.classList.contains('active'));
      }
    }
  });

  $$('.product-form').forEach(form => form.addEventListener('submit', async event => {
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]'); submit.disabled = true;
    try {
      const addons = $$('[data-addon]', form).filter(input => input.checked);
      if (addons.length) {
        // Add the main item and the chosen add-on fee variants in one /cart/add request,
        // storing the card message as a line-item property. FormData keeps photo uploads intact.
        const src = new FormData(form);
        const body = new FormData();
        let i = 0;
        body.append(`items[${i}][id]`, src.get('id'));
        body.append(`items[${i}][quantity]`, src.get('quantity') || '1');
        for (const [key, value] of src.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && !(typeof value === 'string' && value === '')) body.append(`items[${i}][properties][${match[1]}]`, value);
        }
        i += 1;
        for (const addon of addons) {
          body.append(`items[${i}][id]`, addon.dataset.addonVariant);
          body.append(`items[${i}][quantity]`, '1');
          if (addon.hasAttribute('data-addon-message')) {
            const message = form.querySelector('[data-addon-message-input]')?.value.trim();
            if (message) body.append(`items[${i}][properties][Your message]`, message);
          }
          i += 1;
        }
        const response = await fetch(window.themeRoutes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body });
        if (!response.ok) { const result = await response.json().catch(() => null); throw new Error(result?.description || 'Could not add this item'); }
        await afterAdd(await response.json().catch(() => null));
      } else {
        await afterAdd(await addToCart(new FormData(form)));
      }
    }
    catch (error) { showToast(error.message); }
    finally {
      const variantSelect = form.querySelector('.variant-select');
      const selectedOption = variantSelect?.selectedOptions[0];
      submit.disabled = variantSelect ? !variantSelect.value || Boolean(selectedOption?.disabled) : false;
    }
  }));

  const productJson = $('[data-product-json]');
  if (productJson) {
    const variants = JSON.parse(productJson.textContent);
    const productForm = $('[data-product-form]');
    const optionGroups = productForm ? $$('.product-option', productForm) : [];
    // Products whose later options depend on earlier ones (Adult vs Kid sizes, Canvas vs Poster sizes)
    // hide the values no variant offers for the current selection, and move the choice to the
    // best-seller value when offered, else the first offered value. Full option matrices hide nothing.
    const syncOfferedChoices = () => {
      const selected = [];
      optionGroups.forEach((group, index) => {
        const inputs = $$('input', group);
        inputs.forEach(input => {
          const offered = variants.some(item => item.options[index] === input.value
            && selected.every((value, k) => item.options[k] === value));
          input.closest('label').style.display = offered ? '' : 'none';
          input.disabled = !offered;
          if (!offered) input.checked = false;
        });
        if (!group.querySelector('input:checked')) {
          const offered = inputs.filter(input => !input.disabled);
          const preferred = offered.find(input => input.hasAttribute('data-best-seller')) || offered[0];
          if (preferred) preferred.checked = true;
        }
        selected.push(group.querySelector('input:checked')?.value);
      });
    };
    syncOfferedChoices();
    $$('.product-option input', productForm).forEach(input => input.addEventListener('change', () => {
      syncOfferedChoices();
      const selected = optionGroups.map(group => group.querySelector('input:checked')?.value);
      const variant = variants.find(item => item.options.every((option, index) => option === selected[index]));
      const variantSelect = $('.variant-select');
      const submit = $('.product-submit');
      if (!variant) {
        variantSelect.value = '';
        submit.disabled = true;
        submit.textContent = 'UNAVAILABLE';
        return;
      }
      variantSelect.value = variant.id;
      const price = $('[data-product-price]');
      const compareAt = variant.compare_at_price > variant.price ? variant.compare_at_price : null;
      const discount = compareAt ? Math.round(((compareAt - variant.price) * 100) / compareAt) : 0;
      if (price) price.innerHTML = `<span>${money(variant.price)}</span>${compareAt ? ` <s>${money(compareAt)}</s><em>${discount}% OFF</em>` : ''}`;
      submit.disabled = !variant.available; submit.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      submit.dataset.available = variant.available ? '1' : '0';
      history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
      document.dispatchEvent(new CustomEvent('pdp:variant'));
    }));
  }

  // Gift add-ons: reveal the message field, and show a running total (variant + selected add-ons)
  // on the add-to-cart button for ornaments.
  const giftAddons = $('[data-gift-addons]');
  if (giftAddons) {
    const submit = $('.product-submit');
    const messageField = $('[data-addon-message-field]', giftAddons);
    const baseCents = () => {
      const text = $('[data-product-price] span')?.textContent || '';
      return Math.round((parseFloat(text.replace(/[^0-9.]/g, '')) || 0) * 100);
    };
    const updateTotal = () => {
      if (!submit || submit.dataset.available === '0') return;
      let cents = baseCents();
      $$('[data-addon]', giftAddons).forEach(addon => { if (addon.checked) cents += Number(addon.dataset.addonPrice) || 0; });
      submit.textContent = `Add to cart — ${money(cents)}`;
    };
    giftAddons.addEventListener('change', event => {
      if (event.target.hasAttribute('data-addon-message') && messageField) messageField.hidden = !event.target.checked;
      updateTotal();
    });
    document.addEventListener('pdp:variant', updateTotal);
    updateTotal();
  }

  const gallery = $('[data-product-gallery]');
  if (gallery) {
    const slides = $$('.product-media', gallery);
    const thumbs = $$('.product-gallery__thumb', gallery);
    let current = Math.max(0, slides.findIndex(slide => slide.classList.contains('active')));
    const resetZoom = () => slides.forEach(slide => {
      const img = slide.querySelector('img');
      if (img) { img.style.transform = ''; img.style.transformOrigin = ''; }
    });
    const show = index => {
      current = (index + slides.length) % slides.length;
      resetZoom();
      slides.forEach((slide, i) => slide.classList.toggle('active', i === current));
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('active', i === current);
        thumb.setAttribute('aria-pressed', String(i === current));
      });
      thumbs[current]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    };
    $('[data-gallery-prev]')?.addEventListener('click', () => show(current - 1));
    $('[data-gallery-next]')?.addEventListener('click', () => show(current + 1));
    thumbs.forEach(thumb => thumb.addEventListener('click', () => show(Number(thumb.dataset.thumbIndex))));

    const stage = $('.product-gallery__stage', gallery);
    // Customily injects a live-preview canvas and an inline !important minimum
    // height. Keep the product photo in its normal gallery instead of letting
    // that canvas reserve more space as shoppers personalize.
    if (stage) {
      const clearCustomilyPreviewHeight = () => {
        if (stage.querySelector(':scope > .cl-canvas-container') && stage.style.getPropertyValue('min-height')) {
          stage.style.removeProperty('min-height');
        }
      };
      new MutationObserver(clearCustomilyPreviewHeight).observe(stage, {
        attributes: true,
        attributeFilter: ['style'],
        childList: true
      });
      clearCustomilyPreviewHeight();
    }
    // Hover zoom-and-pan: on fine-pointer devices, magnify the region of the active image
    // under the cursor within the stage frame (stage clips the overflow). Touch is left untouched.
    if (stage && window.matchMedia('(pointer:fine)').matches) {
      const zoomScale = 2.4;
      const activeImg = () => stage.querySelector('.product-media.active img');
      stage.classList.add('is-zoomable');
      stage.addEventListener('mousemove', event => {
        // Customily's live-preview canvas has its own hover zoom; stacking ours would double-scale.
        if (stage.querySelector(':scope > .cl-canvas-container')) { resetZoom(); return; }
        const img = activeImg();
        if (!img) return;
        const rect = stage.getBoundingClientRect();
        const x = Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100));
        const y = Math.min(100, Math.max(0, ((event.clientY - rect.top) / rect.height) * 100));
        img.style.transformOrigin = `${x}% ${y}%`;
        img.style.transform = `scale(${zoomScale})`;
      });
      stage.addEventListener('mouseleave', resetZoom);
    }
  }
  // Keep native variants first, then Customily and our custom fields. Quantity stays
  // below customization, immediately before Add to Cart.
  const customilyForm = $('[data-product-form]');
  if (customilyForm) {
    const placeCustomilyOptions = () => {
      const options = $(':scope > #customily-options', customilyForm);
      if (!options) return false;
      const customFields = $('[data-magic-personalizer]', customilyForm);
      const quantity = $('.product-quantity', customilyForm);
      const next = customFields || quantity || $('.product-submit', customilyForm);
      if (next && next !== options) customilyForm.insertBefore(options, next);
      return true;
    };
    if (!placeCustomilyOptions()) {
      const observer = new MutationObserver(() => {
        if (placeCustomilyOptions()) observer.disconnect();
      });
      observer.observe(customilyForm, { childList: true });
    }
    // Customily renders its Preview button late and wherever its layout setting puts it;
    // keep it directly above the visible Add to Cart, which is Customily's #customily-cart-btn
    // clone when present (the theme's submit is then hidden behind it). Gift add-ons sit
    // directly above Preview so they follow Customily's options.
    const placeCustomilyPreview = () => {
      const preview = $('#customily-preview-button', customilyForm);
      const submit = $('#customily-cart-btn', customilyForm) || $('button[type="submit"]', customilyForm);
      if (preview && submit && submit.previousElementSibling !== preview) submit.before(preview);
      const gift = $('[data-gift-addons]', customilyForm);
      if (preview && gift && preview.previousElementSibling !== gift) preview.before(gift);
    };
    placeCustomilyPreview();
    new MutationObserver(placeCustomilyPreview).observe(customilyForm, { childList: true, subtree: true });
  }

  $('[data-customize-cta]')?.addEventListener('click', () => {
    const panel = $('[data-magic-personalizer]');
    if (!panel) return;
    panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    panel.querySelector('input, textarea, select')?.focus({ preventScroll: true });
  });

  $$('.quantity-stepper').forEach(stepper => {
    const input = $('input[type="number"]', stepper);
    const update = delta => {
      const minimum = Number(input.min) || 1;
      input.value = Math.max(minimum, (Number(input.value) || minimum) + delta);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    $('[data-quantity-minus]', stepper)?.addEventListener('click', () => update(-1));
    $('[data-quantity-plus]', stepper)?.addEventListener('click', () => update(1));
  });

  // Default Shipping Protection applies once per real product line, never to cart add-ons.
  // Persist each customer's opt-out so refreshing the cart does not re-add a declined line.
  const cartExperience = $('[data-cart-experience]');
  if (cartExperience) {
    const toggles = $$('[data-cart-extra-toggle]', cartExperience);
    const status = $('[data-cart-extra-status]', cartExperience);
    const cartForm = $('form', cartExperience);
    const protectionVariantId = Number(cartExperience.dataset.protectionVariantId) || 0;
    const PROTECTION_HANDLE = 'len-shipping-protection';
    const ADDON_HANDLES = new Set([PROTECTION_HANDLE, 'len-priority-production', 'len-gift-box', 'len-message-card']);
    const isMerchandise = item => item.product_type !== CART_ADDON_TYPE && !ADDON_HANDLES.has(item.handle);
    let quantityUpdateTimer;

    const requestCart = async (path, payload) => {
      const response = await fetch(path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      const result = await response.json().catch(() => null);
      if (!response.ok) throw new Error(result?.description || 'Could not update your cart. Please try again.');
      return result;
    };
    const getCart = async () => (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    const setBusy = (busy, message = '') => {
      toggles.forEach(toggle => { toggle.disabled = busy; });
      if (status) status.textContent = message;
    };
    const protectionOptOut = cart => new Set((cart.attributes?._protection_opt_out || '').split(',').filter(Boolean));
    const protectionProperties = product => ({
      '_Cart extra': 'Shipping Protection', '_protects': product.key, '_Protected item': product.product_title
    });
    const toggleProtection = async (toggle, enabled) => {
      const protectsKey = toggle.dataset.protectsKey;
      const cart = await getCart();
      const product = cart.items.find(i => i.key === protectsKey && isMerchandise(i));
      if (!product) throw new Error('This product is no longer in your cart.');
      const optOut = protectionOptOut(cart);
      const line = cart.items.find(i => i.handle === PROTECTION_HANDLE && i.properties?._protects === protectsKey);
      if (enabled) {
        if (!line) await requestCart('/cart/add.js', { items: [{ id: protectionVariantId, quantity: 1, properties: protectionProperties(product) }] });
        optOut.delete(protectsKey);
        await requestCart('/cart/update.js', { attributes: { _protection_opt_out: [...optOut].join(',') } });
      } else {
        optOut.add(protectsKey);
        await requestCart('/cart/update.js', { attributes: { _protection_opt_out: [...optOut].join(',') } });
        if (line) await requestCart('/cart/change.js', { id: line.key, quantity: 0 });
      }
    };
    // Priority Production: a single per-order line.
    const togglePriority = async (toggle, enabled) => {
      const cart = await getCart();
      const line = cart.items.find(i => i.variant_id === Number(toggle.dataset.variantId));
      if (enabled && !line) {
        await requestCart('/cart/add.js', { items: [{ id: Number(toggle.dataset.variantId), quantity: 1, properties: { '_Cart extra': 'Priority Production' } }] });
      } else if (!enabled && line) {
        await requestCart('/cart/update.js', { updates: { [line.key]: 0 } });
      }
    };
    const updateExtra = async (toggle, enabled) => {
      setBusy(true, 'Updating your cart…');
      try {
        if (toggle.dataset.extraKind === 'protection') await toggleProtection(toggle, enabled);
        else await togglePriority(toggle, enabled);
        location.reload();
      } catch (error) {
        toggle.checked = !enabled;
        setBusy(false, error.message);
      }
    };
    toggles.forEach(toggle => toggle.addEventListener('change', () => updateExtra(toggle, toggle.checked)));
    $$('[data-cart-addon-remove]', cartExperience).forEach(link => {
      link.addEventListener('click', async event => {
        event.preventDefault();
        if (link.getAttribute('aria-disabled') === 'true') return;
        link.setAttribute('aria-disabled', 'true');
        if (status) status.textContent = 'Removing gift add-on…';
        try {
          await requestCart('/cart/change.js', { id: link.dataset.addonLineKey, quantity: 0 });
          location.reload();
        } catch (error) {
          link.removeAttribute('aria-disabled');
          if (status) status.textContent = error.message;
        }
      });
    });
    $$('input[name^="updates["]', cartExperience).forEach(input => {
      input.addEventListener('change', () => {
        clearTimeout(quantityUpdateTimer);
        if (status) status.textContent = 'Updating your cart…';
        quantityUpdateTimer = setTimeout(() => cartForm?.requestSubmit(), 500);
      });
    });

    // Reconcile only merchandise protection; cart add-ons never receive protection.
    (async () => {
      if (!protectionVariantId) return;
      try {
        const cart = await getCart();
        const optOut = protectionOptOut(cart);
        const merch = cart.items.filter(isMerchandise);
        const merchKeys = new Set(merch.map(item => item.key));
        const protectedLines = cart.items.filter(item => item.handle === PROTECTION_HANDLE);
        const adds = merch.filter(item => !optOut.has(item.key) && !protectedLines.some(line => line.properties?._protects === item.key))
          .map(item => ({ id: protectionVariantId, quantity: 1, properties: protectionProperties(item) }));
        const removes = protectedLines.filter(line => {
          const protects = line.properties?._protects;
          return !merchKeys.has(protects) || optOut.has(protects);
        });
        if (adds.length) await requestCart('/cart/add.js', { items: adds });
        for (const line of removes) await requestCart('/cart/change.js', { id: line.key, quantity: 0 });
        if (adds.length || removes.length) location.reload();
      } catch (e) { /* leave the cart as-is if reconciliation fails */ }
    })();
  }

  $$('[data-product-tabs]').forEach(tabs => {
    const buttons = $$('[role="tab"]', tabs);
    const panels = $$('[role="tabpanel"]', tabs);
    const compactTabs = window.matchMedia('(max-width: 749px)');
    let resizeFrame;
    const syncPanelHeight = () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => {
        if (compactTabs.matches) {
          tabs.style.removeProperty('--product-tab-panel-height');
          return;
        }
        tabs.style.removeProperty('--product-tab-panel-height');
        const panelWidth = tabs.clientWidth;
        let tallestPanel = 0;
        panels.forEach(panel => {
          const wasHidden = panel.hidden;
          const previousStyle = panel.getAttribute('style');
          panel.hidden = false;
          Object.assign(panel.style, {
            position: 'absolute',
            visibility: 'hidden',
            pointerEvents: 'none',
            width: `${panelWidth}px`
          });
          tallestPanel = Math.max(tallestPanel, panel.scrollHeight);
          if (previousStyle === null) panel.removeAttribute('style');
          else panel.setAttribute('style', previousStyle);
          panel.hidden = wasHidden;
        });
        tabs.style.setProperty('--product-tab-panel-height', `${Math.ceil(tallestPanel)}px`);
      });
    };
    const activate = button => {
      buttons.forEach(item => {
        item.setAttribute('aria-selected', String(item === button));
        item.setAttribute('tabindex', item === button ? '0' : '-1');
      });
      panels.forEach(panel => { panel.hidden = panel.id !== button.getAttribute('aria-controls'); });
    };
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button));
      button.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        buttons[next].focus(); activate(buttons[next]);
      });
    });
    syncPanelHeight();
    window.addEventListener('resize', syncPanelHeight, { passive: true });
    document.fonts?.ready?.then(syncPanelHeight);
    const panelContentObserver = new MutationObserver(syncPanelHeight);
    panels.forEach(panel => panelContentObserver.observe(panel, { childList: true, subtree: true, characterData: true }));
    $$('img', tabs).forEach(image => {
      if (image.complete) syncPanelHeight();
      else image.addEventListener('load', syncPanelHeight, { once: true });
    });
  });

  const menu = $('.mobile-nav');
  $('.mobile-menu')?.addEventListener('click', () => { menu.classList.add('open'); $('.mobile-menu').setAttribute('aria-expanded', 'true'); });
  $('.close-menu')?.addEventListener('click', () => { menu.classList.remove('open'); $('.mobile-menu').setAttribute('aria-expanded', 'false'); });
  $$('.mobile-nav a').forEach(link => link.addEventListener('click', () => menu?.classList.remove('open')));

  const backTop = $('.back-top');
  window.addEventListener('scroll', () => backTop?.classList.toggle('visible', scrollY > 600), { passive: true });
  backTop?.addEventListener('click', () => window.scrollTo({
    top: 0,
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
  }));

  const filterTrigger = $('[data-filter-open]');
  const filterPanel = $('[data-filter-panel]');
  const filterBackdrop = $('[data-filter-backdrop]');
  const filterClose = $('[data-filter-close]');
  if (filterTrigger && filterPanel && filterBackdrop) {
    filterPanel.setAttribute('role', 'dialog');
    filterPanel.setAttribute('aria-modal', 'true');
    filterPanel.setAttribute('aria-hidden', 'true');
    const setFilterOpen = open => {
      filterPanel.classList.toggle('open', open);
      filterPanel.setAttribute('aria-hidden', String(!open));
      filterBackdrop.hidden = !open;
      filterTrigger.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('filter-panel-open', open);
      if (open) filterClose?.focus(); else filterTrigger.focus();
    };
    filterTrigger.addEventListener('click', () => setFilterOpen(true));
    filterClose?.addEventListener('click', () => setFilterOpen(false));
    filterBackdrop.addEventListener('click', () => setFilterOpen(false));
    filterPanel.addEventListener('keydown', event => {
      if (event.key === 'Escape') { setFilterOpen(false); return; }
      if (event.key !== 'Tab') return;
      const focusable = $$('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),summary', filterPanel).filter(item => item.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0]; const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }

  $$('[data-product-recommendations]').forEach(async container => {
    if (!container.dataset.recommendationsUrl) return;
    try {
      const response = await fetch(container.dataset.recommendationsUrl);
      const html = document.createElement('div'); html.innerHTML = await response.text();
      const replacement = html.querySelector('[data-product-recommendations]');
      if (replacement?.innerHTML.trim()) container.innerHTML = replacement.innerHTML;
    } catch (error) { console.warn('Product recommendations unavailable', error); }
  });

  // Links (e.g. the star rating) can jump straight to a specific product tab.
  $$('[data-open-tab]').forEach(link => link.addEventListener('click', () => {
    const button = document.getElementById(link.dataset.openTab);
    if (button) { button.click(); button.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }));

  // Reflect stored favorites in the header badge and on any product-card hearts.
  Favorites.updateCount();
  $$('.product-card .heart').forEach(heart => {
    const card = heart.closest('.product-card');
    if (Favorites.has(card?.dataset.productHandle)) setHeart(heart, true);
  });

  // Favorite items page: rebuild cards from the visitor's saved favorites.
  const favGrid = $('[data-favorites-grid]');
  if (favGrid) {
    const favEmpty = $('[data-favorites-empty]');
    const renderFavorites = () => {
      const items = Favorites.list();
      if (favEmpty) favEmpty.hidden = items.length > 0;
      favGrid.innerHTML = items.map(item => `
        <article class="product-card" data-product-handle="${escapeAttr(item.handle)}">
          <div class="product-card__media product-photo">
            <a class="product-card__image-link" href="${escapeAttr(item.url)}" aria-label="${escapeAttr(item.title)}">${item.image ? `<img src="${escapeAttr(item.image)}" alt="${escapeAttr(item.title)}" loading="lazy">` : ''}</a>
            <button type="button" class="heart active" aria-pressed="true" aria-label="Remove ${escapeAttr(item.title)} from favorites" data-fav-remove="${escapeAttr(item.handle)}">♥</button>
          </div>
          <h3 class="product-card__title"><a href="${escapeAttr(item.url)}">${escapeAttr(item.title)}</a></h3>
          <p class="price product-card__price">${item.priceHtml || ''}</p>
          ${item.ratingHtml || '<div class="product-rating product-rating--empty" aria-hidden="true"></div>'}
        </article>`).join('');
    };
    favGrid.addEventListener('click', event => {
      const removeButton = event.target.closest('[data-fav-remove]');
      if (!removeButton) return;
      event.preventDefault();
      Favorites.remove(removeButton.dataset.favRemove);
      renderFavorites();
    });
    renderFavorites();
  }
})();
